import { SprintCalendar } from "@/components/home/sprint-calendar";

const PHASES = [
  {
    t: "Days 1 to 7",
    b: "Kickoff, product strategy and a locked scope on day 1. Then the design system and core screens, with the build starting underneath.",
  },
  {
    t: "Days 8 to 14",
    b: "Accounts, data, payments and integrations. A performance, accessibility and SEO pass. Live on your domain on day 14.",
  },
  {
    t: "After launch",
    b: "Brand, launch site, motion, film and decks from the same studio. Or keep the team on two-week sprints.",
  },
];

/** The method: a real two-week product calendar, then three short lines. */
export function HowWeWork() {
  return (
    <section
      id="how"
      aria-labelledby="how-h"
      className="relative mx-auto max-w-[1400px] border-t border-border/60 px-6 py-20 md:px-10 md:py-32"
    >
      <div className="max-w-[46ch]">
        <h2 id="how-h" className="fluid-h2 font-display tracking-[-0.035em]">
          How we work
        </h2>
        <p className="mt-5 text-pretty text-lg leading-snug text-muted-foreground md:text-xl">
          All 14 days on one calendar, starting today. Scope locked on day 1, live on day 14.
        </p>
      </div>

      <div className="mt-12">
        <SprintCalendar />
      </div>

      <ol className="mt-12 grid gap-8 md:grid-cols-3 md:gap-10">
        {PHASES.map((p) => (
          <li key={p.t} className="rounded-[1.5rem] bg-secondary/60 p-6 ring-1 ring-foreground/[0.04] md:p-7">
            <h3 className="font-display text-xl tracking-[-0.02em] md:text-2xl">{p.t}</h3>
            <p className="mt-2 max-w-[36ch] text-pretty text-base leading-relaxed text-muted-foreground">
              {p.b}
            </p>
          </li>
        ))}
      </ol>
    </section>
  );
}
